import * as React from 'react';
import {useIntl} from 'react-intl';

import styles from './EventAnnotationType.less';
import {
  baseEventAnnotationTypeParams,
  BaseEventAnnotationTypeParams,
} from 'src/js/lib/raw_rendering/base_event_annotation_type_params';

type Props = BaseEventAnnotationTypeParams;

export const EventAnnotationType: React.FC<Props> = (props) => {
  const intl = useIntl();
  const {annotationLabel} = baseEventAnnotationTypeParams(props, {intl});

  return <div className={styles.dlEventAnnotationType}>{annotationLabel}</div>;
};

EventAnnotationType.displayName = 'EventAnnotationType';
